import Information from './Information'
import Setting from './Setting'
import Statement from '../ContentDeliveryNetwork/Statement'
import Monitoring from './Monitoring'

const StorageOSS = {
    Information,
    Setting,
    Statement,
    Monitoring,
}

export default StorageOSS
